function initVideoCards() {

  const videoWrappers = document.querySelectorAll(".with-button");

  videoWrappers.forEach((wrapper) => {

    // prevent duplicate init
    if (wrapper.dataset.videoInit === "true") return;
    wrapper.dataset.videoInit = "true";

    const video = wrapper.querySelector("video");
    const playButton = wrapper.querySelector(".play");
    const soundButton = wrapper.querySelector(".sound");

    if (!video || !playButton || !soundButton) return;

    // ======================
    // VIDEO SETUP
    // ======================

    video.autoplay = true;
    video.loop = true;
    video.playsInline = true;
    video.muted = true;

    // autoplay after refresh
    video.play().catch(() => {});

    // ======================
    // INITIAL UI
    // ======================

    updatePlayButton(video, playButton);
    updateSoundButton(video, soundButton);

    // ======================
    // PLAY / PAUSE
    // ======================

    playButton.addEventListener("click", function (e) {

      e.preventDefault();
      e.stopPropagation();

      if (video.paused) {

        video.play();

      } else {

        video.pause();

      }

    });

    // ======================
    // SOUND
    // ======================

    soundButton.addEventListener("click", function (e) {

      e.preventDefault();
      e.stopPropagation();

      video.muted = !video.muted;

      updateSoundButton(video, soundButton);

    });

    // ======================
    // SYNC UI
    // ======================

    video.addEventListener("play", function () {

      updatePlayButton(video, playButton);

    });

    video.addEventListener("pause", function () {

      updatePlayButton(video, playButton);

    });

  });

}

// ======================
// PLAY BUTTON UI
// ======================

function updatePlayButton(video, button) {

  const svg = button.querySelector("svg");

  if (!svg) return;

  // PLAYING
  if (!video.paused) {

    // IMPORTANT:
    // keep class "play"
    button.setAttribute(
      "class",
      "play absolute inset-0 m-auto flex h-12 w-12 items-center justify-center rounded-full bg-background/90 text-brand-navy shadow-md transition hover:scale-110 opacity-0 group-hover:opacity-100 z-20"
    );

    svg.setAttribute(
      "class",
      "lucide lucide-pause h-5 w-5 fill-current"
    );

    svg.innerHTML = `
      <rect x="14" y="4" width="4" height="16" rx="1"></rect>
      <rect x="6" y="4" width="4" height="16" rx="1"></rect>
    `;

  }

  // PAUSED
  else {

    button.setAttribute(
      "class",
      "play absolute inset-0 m-auto flex h-12 w-12 items-center justify-center rounded-full bg-background/90 text-brand-navy shadow-md transition hover:scale-110 opacity-100 z-20"
    );

    svg.setAttribute(
      "class",
      "lucide lucide-play ml-0.5 h-5 w-5 fill-current"
    );

    svg.innerHTML = `
      <polygon points="6 3 20 12 6 21 6 3"></polygon>
    `;

  }

}

// ======================
// SOUND BUTTON UI
// ======================

function updateSoundButton(video, button) {

  const svg = button.querySelector("svg");

  if (!svg) return;

  // MUTED
  if (video.muted) {

    svg.innerHTML = `
      <path d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z"></path>
      <line x1="22" x2="16" y1="9" y2="15"></line>
      <line x1="16" x2="22" y1="9" y2="15"></line>
    `;

  }

  // UNMUTED
  else {

    svg.innerHTML = `
      <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
      <path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path>
      <path d="M19.07 4.93a10 10 0 0 1 0 14.14"></path>
    `;

  }

}

// ======================
// INIT
// ======================

document.addEventListener("DOMContentLoaded", initVideoCards);

document.addEventListener(
  "shopify:section:load",
  initVideoCards
);
document.addEventListener("DOMContentLoaded", () => {

  const stickyBar = document.querySelector(".fixed.bottom-0");

  if (!stickyBar) return;

  function toggleStickyBar() {

    if (window.scrollY > 200) {

      stickyBar.classList.remove("translate-y-full");
      stickyBar.classList.add("translate-y-0");

    } else {

      stickyBar.classList.remove("translate-y-0");
      stickyBar.classList.add("translate-y-full");

    }

  }

  // run on scroll
  window.addEventListener("scroll", toggleStickyBar);

  // initial check
  toggleStickyBar();

});


(function () {
    function clamp(n, min, max) {
        return Math.min(max, Math.max(min, n));
    }

    function applyCompare(root, pct) {
        var overlay = root.querySelector("[data-compare-overlay]");
        var divider = root.querySelector("[data-compare-divider]");
        var handle = root.querySelector("[data-compare-handle]");
        var input = root.querySelector('input[type="range"]');
        if (!overlay || !divider || !handle || !input) return;

        var v = clamp(Number(pct), 0, 100);
        overlay.style.clipPath = "inset(0 0 0 " + v + "%)";
        divider.style.left = v + "%";
        handle.style.left = v + "%";
        if (String(input.value) !== String(v)) input.value = String(v);
    }

    function initCompare(root) {
        var input = root.querySelector('input[type="range"]');
        if (!input) return;

        function syncFromInput() {
            applyCompare(root, input.value);
        }

        input.addEventListener("input", syncFromInput);
        input.addEventListener("change", syncFromInput);

        root.addEventListener(
            "pointerdown",
            function (e) {
                if (e.target === input || input.contains(e.target)) return;
                var rect = root.getBoundingClientRect();
                var x = e.clientX - rect.left;
                var pct = clamp((x / rect.width) * 100, 0, 100);
                applyCompare(root, pct);
                input.focus({ preventScroll: true });
            },
            { passive: true }
        );

        syncFromInput();
    }

    document.querySelectorAll("[data-image-compare]").forEach(initCompare);

    function initProductReveal(root) {
        var img = root.querySelector("img");
        var overlay = root.querySelector("[data-product-reveal-overlay]");
        if (!img || !overlay) return;

        var blurOn = ["blur-[3px]", "scale-105"];

        function setRevealed(isRevealed) {
            blurOn.forEach(function (c) {
                if (isRevealed) img.classList.remove(c);
                else img.classList.add(c);
            });
            overlay.classList.toggle("hidden", isRevealed);
            root.setAttribute("aria-pressed", isRevealed ? "true" : "false");
        }

        function toggle() {
            var revealed = overlay.classList.contains("hidden");
            setRevealed(!revealed);
        }

        root.addEventListener("click", function () {
            toggle();
        });

        root.addEventListener("keydown", function (e) {
            if (e.key !== "Enter" && e.key !== " ") return;
            e.preventDefault();
            toggle();
        });

        setRevealed(false);
    }

    document.querySelectorAll("[data-product-reveal]").forEach(initProductReveal);
})();


function initShowMoreReviews() {
    const reviews = document.querySelectorAll(".review-item");
    const button = document.querySelector("[data-show-more-reviews]");
    const defaultVisible = 8;

    // stop if button or reviews not found
    if (!reviews.length || !button) return;

    // Hide reviews after 8
    reviews.forEach((review, index) => {
        if (index >= defaultVisible) {
            review.style.display = "none";
        }
    });

    // Show all reviews on click
    button.addEventListener("click", function () {
        reviews.forEach((review) => {
            review.style.display = "";
        });

        // Hide button after click
        button.style.display = "none";
    });
}

// Shopify section load support
document.addEventListener("DOMContentLoaded", initShowMoreReviews);
document.addEventListener("shopify:section:load", initShowMoreReviews);